import { render } from "./Juego.vue?vue&type=template&id=219461f8&scoped=true"
const script = {}

import "./Juego.vue?vue&type=style&index=0&id=219461f8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219461f8"]])

export default __exports__